export default {
    namespaced: true,
    state: {
        lab_selected : {
            "idlab" : null,
            "kind" : null
        },
        detailLabCBC : []
    },

    getters: {
    },

    mutations: {
        setIDLABSelected (state, lab_selected) {
            state.lab_selected.idlab = lab_selected.idlab
            state.lab_selected.kind = lab_selected.kind
        },


    },

    actions: {

        setupIDLABTarget({commit},lab_selected){
            commit('setIDLABSelected', lab_selected)
        },

    }
}